import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=5f2e8138"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports